<template>
  <generic-modal
    size="large"
    :title="$t('modul settings')"
    icon="settings"
    image="/images/icons/configuration.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui four item top attached tabular menu" ref="tabs">
        <a class="active item" data-tab="date_format">
          <i class="calendar icon"></i> {{ $t("date format") }}</a
        >
        <a class="item" data-tab="currency">
          <i class="currency icon"></i> {{ $t("currency") }}</a
        >
        <a class="item" data-tab="uploads">
          <i class="upload icon"></i> {{ $t("uploads") }}</a
        >
        <a class="item" data-tab="templates">
          <i class="code icon"></i> {{ $t("templates") }}</a
        >
      </div>
      <div class="ui bottom attached active tab segment" data-tab="date_format">
        <date-format-management :settings="settings" />
      </div>
      <div class="ui bottom attached tab segment" data-tab="currency">
        <currency-management :settings="settings" />
      </div>
      <div class="ui bottom attached tab segment" data-tab="uploads">
        <upload-management :settings="settings" />
      </div>
      <div class="ui bottom attached tab segment" data-tab="templates">
        <templates-management />
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, toast, clone } from "@/utils";
import GenericModal from "@/components/GenericModal";
import currency from "@/currency";
import DateFormatManagement from "./DateFormatManagement.vue";
import UploadManagement from "./UploadManagement.vue";
import TemplatesManagement from "./TemplatesManagement.vue";
import CurrencyManagement from "./CurrencyManagement.vue";

export default {
  name: "SettingsConfigureModalIndex",
  components: {
    "generic-modal": GenericModal,
    DateFormatManagement,
    CurrencyManagement,
    UploadManagement,
    TemplatesManagement,
  },
  computed: {},
  data() {
    return {
      settings: {
        simple_date_format: "DD/MM/YYYY",
        detailed_date_format: "DD/MM/YYYY HH:mm",
        second_detailed_date_format: "DD/MM/YYYY HH:mm:ss",
        currency: "Q",
        currency_iso: "GTQ",
        upload_timeout: "60000",
      },
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function (resolve, reject) {
        let moduleConfig = clone(vm.settings);
        local_api(vm, "post", "/system/do-save-configuration", {
          setup: moduleConfig,
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    destroy() {
      this.$destroy();
    },
  },
  created() {},
  mounted() {
    let vm = this;

    local_api(this, "post", "/system/do-get-configuration")
      .then((config) => {
        if (config.simple_date_format)
          vm.settings.simple_date_format = config.simple_date_format;
        if (config.detailed_date_format)
          vm.settings.detailed_date_format = config.detailed_date_format;
        if (config.currency) vm.settings.currency = config.currency;
        if (config.currency_iso) vm.settings.currency_iso = config.currency_iso;
      })
      .catch((err) => {
        toast(this.$el, "error", err);
      });

    window.jQuery(vm.$refs.tabs).find(".item").tab();
  },
  watch: {
    "settings.currency_iso"(newVal) {
      let trgt = currency[newVal];
      if (trgt)
        this.settings.currency = trgt.symbol_native || trgt.symbol || "?";
      else this.settings.currency = "¿";
    },
  },
  updated: function () {
    this.$nextTick(function () {
      window.jQuery(".ui.dropdown").dropdown();
    });
  },
};
</script>
